import { css } from "@emotion/react";
import tokens from "@kibela/design-tokens";

import { fontSize } from "~/client/styles/emotion/mixins/fontSize";

export const featureLabelStyle = css([
  fontSize(11),
  {
    color: tokens.color.text.brand.default.value,
    border: `1px solid ${tokens.color.border.brand.value}`,
    borderRadius: "4px",
    padding: "2px",
    textTransform: "uppercase",
  },
]);
